import React, {Component} from 'react'

class ScrollDown extends Component {
  constructor(props) {
    super(props)
    this.els = {}
  }

  componentDidMount() {
    this.els.element = this.props.proxy.querySelector('.square-button');
    if (this.els.element != undefined) {
      this.els.element.addEventListener('click', () => this.initScroll());
    }

    this.els.titleAuthor = document.querySelector('.title-author');
    if (this.els.titleAuthor) {
        let h = this.els.titleAuthor.offsetHeight;
        h += parseInt(window.getComputedStyle(this.els.titleAuthor).getPropertyValue('margin-top'));
        h += parseInt(window.getComputedStyle(this.els.titleAuthor).getPropertyValue('margin-bottom'));
        this.setState({h}, () => {
            this.els.element.style.marginTop = `-${this.state.h}px`
        })
    }
  }

  initScroll() {
    let scrollTo = (this.els.element.getBoundingClientRect().top + window.scrollY) - document.querySelector('header').clientHeight + this.els.element.clientHeight;
    TweenMax.to(window, 1, {scrollTo: {y: scrollTo}});
  }

  render() {
    return <div></div>
  }

}

export default ScrollDown



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/ScrollDown.js